import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { SourceSystem } from '../../models/customer.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class SourceSystemService {
  private baseUrl = 'koncentro-customers';
  sourceSystems: SourceSystem[];
  sourceSystemEditing: SourceSystem;
  private cachedFields: Observable<any>;

  constructor(
    private httpClient: HttpClientService,
    private messageService: MessageService
  ) { }

  getList() {
    return this.httpClient.get(`/${this.baseUrl}/source-systems`)
      .map(res => {
        return this.sourceSystems = res;
      });
  }

  delete(record) {
    return this.httpClient.delete(`/${this.baseUrl}/source-systems/` + record.id)
      .map(res => {
        this.sourceSystems.splice(this.sourceSystems.indexOf(record), 1);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Source system deleted'});
      });
  }

  post(newData) {
    return this.httpClient.post(`/${this.baseUrl}/source-systems`, newData)
      .map(res => {
        newData.id = res.id;
        this.sourceSystems.push(newData);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Source system added'});
      });
  }

  put(newData, id) {
    let oldData = this.sourceSystems.find((sourceSystem) => sourceSystem.id === id);
    return this.httpClient.put(`/${this.baseUrl}/source-systems/` + id, newData)
      .map(res => {
        Object.assign(oldData, newData);
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.httpClient.get('/koncentro-customers/schema/SourceSystemDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getListWithParams(search?: Array<{ key: string, value: string }>): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    if ( search ) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }
    return this.httpClient.get(`/${this.baseUrl}/source-systems?`+ params.toString())
      .map(res => {
        return this.sourceSystems = res;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/source-system/source-system.service.ts